module.exports = __webpack_public_path__ + "img/new-york-islanders.32dbf51f.svg";